import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Crud, CrudService, ConfigServerService, CustomHttp } from '../../../../core';
import { Representante } from '../representante';
import { RepresentanteSearchAsync } from '../representante-search-async';
import { RepresentanteFilter } from '../filter';

@Injectable({
    providedIn: 'root'
})
export class RepresentanteCrudHttpService implements Crud<Representante> {
    resource = 'representante';
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private crudService: CrudService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${this.resource}`;
    }

    /** Pesquisa todos os representantes cadastrados */
    search(): Observable<Representante[]> {
        return new Observable<Representante[]>();
    }

    // searchWithFilter(filter: RepresentanteFilter, drawDatatable: number = null, offset: number = null, limit: number = null, orderBy: number = null, orderByDir: string = null): Observable<RepresentanteSearchAsync> {
    //     // Params
    //     let params = new HttpParams()
    //                      .append('drawDatatable', drawDatatable ? drawDatatable.toString() : null)
    //                      .append('offset', offset ? offset.toString() : null)
    //                      .append('limit', limit ? limit.toString() : null)
    //                      .append('orderBy', orderBy ? orderBy.toString() : null)
    //                      .append('orderByDir', orderByDir ? orderByDir : '');

    //      if (filter) {
    //          params = filter.createParams(params);
    //      }

    //      return this.customHttp.get<RepresentanteSearchAsync>(this.pathApi, {params: params});
    //  }

    /** Procura um único representante através do seu ID */
    find(id: number): Observable<Representante> {
        return this.crudService.find<Representante>(this.resource, id);
    }

    /** Carrega um único representante através do seu ID */
    load(id: number): Observable<Representante> {
        return this.crudService.load<Representante>(this.resource, id)
        .pipe(
            map(representante => {
                // Classificações
                representante?.classificacoesClientes?.forEach(classificacaoCliente => {
                    // Setando que pode editar a classificação
                    classificacaoCliente.canEdit = true;
                    // Setando que as classificações não são obrigatória
                    classificacaoCliente.obrigatorio = false;
                })

                return representante;
            })
        );
    }

    /** Insere um novo representante */
    insert(entity: Representante): Observable<Representante> {
        return this.crudService.insert<Representante>(this.resource, entity);
    }

    /** Altera um representante existente */
    update(entity: Representante): Observable<Representante> {
        return this.crudService.update<Representante>(this.resource, entity);
    }

    /** Exclui um representante através do seu ID */
    delete(id: number, deletePessoa = true): Observable<string> {
        // Params
        const params = new HttpParams()
                            .append('deletePessoa', (deletePessoa != null && deletePessoa !== undefined) ? deletePessoa.toString() : null); // Se é para excluir a pessoa também

        return this.customHttp.delete<string>(`${this.pathApi}/${id}`, {params, responseType: 'text'});
    }
}
